import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";

import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";

import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Marketplace from "@/pages/Marketplace";
import InventoryDetail from "@/pages/InventoryDetail";
import AIPlanner from "@/pages/AIPlanner";
import Cities from "@/pages/Cities";
import CityDetail from "@/pages/CityDetail";
import Industries from "@/pages/Industries";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import AuthPage from "@/pages/AuthPage";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminClients from "@/pages/admin/AdminClients";
import AdminMalls from "@/pages/admin/AdminMalls";
import AdminMallDetail from "@/pages/admin/AdminMallDetail";
import AdminUsers from "@/pages/admin/AdminUsers";

import AdvertiserLayout from "@/pages/advertiser/AdvertiserLayout";
import AdvertiserOverview from "@/pages/advertiser/AdvertiserOverview";
import AdvertiserShortlist from "@/pages/advertiser/AdvertiserShortlist";
import AdvertiserPlans from "@/pages/advertiser/AdvertiserPlans";
import AdvertiserOrders from "@/pages/advertiser/AdvertiserOrders";

import MallOwnerLayout from "@/pages/mall-owner/MallOwnerLayout";
import MallOwnerOverview from "@/pages/mall-owner/MallOwnerOverview";
import MallOwnerMalls from "@/pages/mall-owner/MallOwnerMalls";
import MallOwnerInventory from "@/pages/mall-owner/MallOwnerInventory";
import MallOwnerBookings from "@/pages/mall-owner/MallOwnerBookings";

import ScrollToTop from "@/components/common/ScrollToTop";

function PublicShell({ children }) {
  return (
    <div className="App">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster theme="dark" position="top-right" />
      <Routes>
        {/* Public site */}
        <Route path="/" element={<PublicShell><Home /></PublicShell>} />
        <Route path="/solutions" element={<PublicShell><Solutions /></PublicShell>} />
        <Route path="/marketplace" element={<PublicShell><Marketplace /></PublicShell>} />
        <Route path="/inventory/:id" element={<PublicShell><InventoryDetail /></PublicShell>} />
        <Route path="/ai-planner" element={<PublicShell><AIPlanner /></PublicShell>} />
        <Route path="/cities" element={<PublicShell><Cities /></PublicShell>} />
        <Route path="/cities/:city" element={<PublicShell><CityDetail /></PublicShell>} />
        <Route path="/industries" element={<PublicShell><Industries /></PublicShell>} />
        <Route path="/case-studies" element={<PublicShell><CaseStudies /></PublicShell>} />
        <Route path="/case-studies/:id" element={<PublicShell><CaseStudyDetail /></PublicShell>} />
        <Route path="/resources" element={<PublicShell><Resources /></PublicShell>} />
        <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />

        {/* Universal auth */}
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/register" element={<AuthPage mode="register" />} />

        {/* Admin (super-admin + legacy admin) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="malls" element={<AdminMalls />} />
          <Route path="malls/:id" element={<AdminMallDetail />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="inventory" element={<AdminInventory />} />
          <Route path="plans" element={<AdminPlans />} />
          <Route path="clients" element={<AdminClients />} />
        </Route>

        {/* Advertiser */}
        <Route path="/advertiser" element={<AdvertiserLayout />}>
          <Route index element={<AdvertiserOverview />} />
          <Route path="shortlist" element={<AdvertiserShortlist />} />
          <Route path="plans" element={<AdvertiserPlans />} />
          <Route path="orders" element={<AdvertiserOrders />} />
        </Route>

        {/* Mall admin (a.k.a. mall_owner role internally) */}
        <Route path="/mall-owner" element={<MallOwnerLayout />}>
          <Route index element={<MallOwnerOverview />} />
          <Route path="malls" element={<MallOwnerMalls />} />
          <Route path="inventory" element={<MallOwnerInventory />} />
          <Route path="bookings" element={<MallOwnerBookings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
